import React, { useRef, useState } from "react";
import { useProductForm } from "../../contexts/ProductFormContext";
import { ImBin } from "react-icons/im";
import { CiImageOn } from "react-icons/ci";
import Lottie from "lottie-react";
import loading from "../../animations/loading.json";
import { IoIosCloseCircle } from "react-icons/io";
import { useFileUpload } from "../../hooks/useFileUpload";
import { API } from "../../configs/endpoints";
import type { Image } from "../../types/common/image";

export const SeoTab = () => {
  const [keyword, setKeyword] = useState<string>("");
  const { product, setProduct } = useProductForm();
  const inputRef = useRef<HTMLInputElement>(null);
  const { upload, isUploading: isChooseImage } = useFileUpload<{
    image: Image;
  }>({
    endpoint: API.product.uploadOgImage,
    kind: "image",
  });
  const handleChooseImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    const result = await upload(file);
    e.target.value = "";
    if (result.ok && result.data?.image) {
      setProduct((prev) => ({
        ...prev,
        product: {
          ...prev.product,
          seo: { ...prev.product.seo, ogImage: result.data!.image },
        },
      }));
    }
  };
  return (
    <div className="p-5 rounded-xl border border-gray-100 bg-white space-y-2">
      <h2 className="text-lg font-semibold text-black">Seo</h2>
      <div className="space-y-2">
        <label className="block text-sm text-gray-700 font-semibold">
          Tiều đề
        </label>
        <input
          type="text"
          name="title"
          value={product.product.seo.title}
          onChange={(e) =>
            setProduct((prev) => ({
              ...prev,
              product: {
                ...prev.product,
                seo: {
                  ...prev.product.seo,
                  title: e.target.value,
                },
              },
            }))
          }
          className="p-2 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 transition-colors duration-300 w-full placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
          placeholder="Nhập tiêu đề"
        />
      </div>
      <div className="space-y-2">
        <label className="block text-sm text-gray-700 font-semibold">
          Mô tả
        </label>
        <textarea
          name="description"
          value={product.product.seo.description}
          onChange={(e) =>
            setProduct((prev) => ({
              ...prev,
              product: {
                ...prev.product,
                seo: { ...prev.product.seo, description: e.target.value },
              },
            }))
          }
          className="p-2 h-40 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 transition-colors duration-300 w-full placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
          placeholder="Nhập mô tả"
        />
      </div>
      <div className="space-y-2">
        <label className="block text-sm text-gray-700 font-semibold">
          Từ khóa tìm kiếm
        </label>
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className="p-2 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 transition-colors duration-300 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
            placeholder="Nhập từ khóa tìm kiếm"
          />
          <button
            type="button"
            onClick={() => {
              setProduct((prev) => ({
                ...prev,
                product: {
                  ...prev.product,
                  seo: {
                    ...prev.product.seo,
                    keywords: [...prev.product.seo.keywords, keyword],
                  },
                },
              }));
              setKeyword("");
            }}
            className="p-2 text-sm text-white bg-blue-500 rounded-lg hover:bg-blue-600 cursor-pointer"
          >
            Thêm
          </button>
        </div>
        <div className="">
          <table>
            <thead className="border border-gray-200 bg-blue-50">
              <tr className="divide-x divide-gray-200">
                <th>
                  <p className="p-2 text-[11px] uppercase tracking-wider text-gray-400 font-semibold text-center">
                    Từ khóa tìm kiếm
                  </p>
                </th>
                <th>
                  <p className="p-2 text-[11px] uppercase tracking-wider text-gray-400 font-semibold text-center">
                    Thao tác
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {product.product.seo.keywords.length > 0 ? (
                product.product.seo.keywords.map((item, index) => (
                  <tr
                    key={index}
                    className="divide-x divide-gray-200 border border-gray-200"
                  >
                    <td>
                      <p className="text-sm text-gray-700 text-center p-2">
                        {item}
                      </p>
                    </td>
                    <td>
                      <div className="flex items-center justify-center">
                        <button className="text-lg text-gray-700 hover:text-red-500 cursor-pointer transition-colors duration-300">
                          <ImBin />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    <p className="text-sm text-gray-700 p-2 text-center">
                      Không có từ khóa nào
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="space-y-2">
        <label className="block text-sm text-gray-700 font-semibold">
          Ảnh đại diện
        </label>
        <input
          type="file"
          className="hidden"
          onChange={handleChooseImage}
          ref={inputRef}
        />
        {product.product.seo.ogImage?.public_id ? (
          <div className="w-20 h-20 relative">
            <img
              src={product.product.seo.ogImage.url}
              alt="Ảnh đại diện"
              className="h-full w-full border border-gray-200 rounded-xl"
            />
            <button
              type="button"
              onClick={() => {
                setProduct((prev) => ({
                  ...prev,
                  product: {
                    ...prev.product,
                    seo: {
                      ...prev.product.seo,
                      ogImage: null,
                    },
                  },
                }));
              }}
              className="absolute -top-2 -right-2 text-red-500 hover:text-red-600 cursor-pointer text-xl"
            >
              <IoIosCloseCircle />
            </button>
          </div>
        ) : isChooseImage ? (
          <Lottie animationData={loading} loop={true} className="h-20 w-20" />
        ) : (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="h-20 w-20 border border-gray-200 rounded-xl hover:border-blue-500 transition-colors duration-300 cursor-pointer flex items-center justify-center text-2xl text-gray-700"
          >
            <CiImageOn />
          </button>
        )}
      </div>
    </div>
  );
};
